import React, { Component } from 'react';
import Search from '../Home/Search';
import { Link } from 'react-router-dom';

export class OurContent extends Component {
    displayName = OurContent.name

    render() {
        return (
            <div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-9">
                            <p className="TitlePadding Title"> Our content</p>
                            <p className="TitlePadding BookBody">Kluwer Law Online is a collection of 25 journals, 9 manuals and 25 International Encyclopaedias of Laws focused
                            on key aspects of international law. We provide timely information and insights on the latest developments in
                            international regulations in the following practice areas:</p>

                            <p className="paddingL">  <ul className="ManualUl">
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> Arbitration, Litigation and Mediation</Link> </li>
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> Banking/Finance Law </Link></li>
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> Comparative Law </Link></li>
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> Competition Law </Link></li>
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> Corporate Law/Commercial Law </Link></li>
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> European Union Law</Link> </li>
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> Energy/Environmental Law </Link></li>
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> Energy/Environmental Law </Link></li>
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> Labour and Social Security Law </Link></li>
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> Taxation </Link></li>
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> Trade Law </Link></li>
                                <li><Link className="TitlePadding LinkClass" to="/TopicDescription"> Transport law </Link></li>

                            </ul>
                            </p>
                            <p className="TitlePadding BookBody">
                                Our content is written and reviewed by authors and editors from over 100 different countries who are all experts
in their field. They are academics from some of the highest ranking universities in the world and practitioners
from some of the most prestigious law firms. The website is visited over 60.000 times per month by more than
40.000 legal professionals from countries in all 5 continents.
                            </p>
                        </div>
                    </div>

                    <div className="White">
                    </div>
                    <div className="White">
                    </div>
                </div >
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer Section/OurContent.jsx